import clsx from 'clsx';

export const StatCard = ({ title, value, children, className }) => {
  return (
    <div className={clsx('bg-white/10 backdrop-blur-sm p-4 rounded-lg flex-1', className)}>
      <p className='text-gray-400 text-sm font-medium mb-1'>{title}</p>
      {children ? <div>{children}</div> : <p className='text-lg font-semibold'>{value}</p>}
    </div>
  );
};
